/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { ConvertDatesToStrings } from '@itk/typescript-utils'
import type { Model_EmployeeGet } from '../models/Model_EmployeeGet';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class EmployeeService {
    /**
     * @param id
     * @returns Model_EmployeeGet Success
     * @throws ApiError
     */
    public static getApiV1Employee(
        id: ConvertDatesToStrings<string>,
    ): CancelablePromise<Model_EmployeeGet> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/employee/{id}',
            path: {
                'id': id,
            },
        });
    }
}
